var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8102 28C18.1716 28 17.7052 27.5358 17.7052 26.9065C17.7052 26.5764 17.8269 26.2979 18.0398 26.0916L20.3207 23.7395L23.2606 21.0058L20.8985 21.1502H14.4688C13.7997 21.1502 13.3334 20.6757 13.3334 20.0052C13.3334 19.3243 13.7997 18.8498 14.4688 18.8498H20.8985L23.2504 18.9942L20.3207 16.2605L18.0398 13.9084C17.8269 13.7021 17.7052 13.4236 17.7052 13.0935C17.7052 12.4642 18.1716 12 18.8102 12C19.1042 12 19.3779 12.1135 19.6415 12.3714L26.3018 19.1489C26.535 19.3759 26.6667 19.6854 26.6667 20.0052C26.6667 20.3146 26.535 20.6241 26.3018 20.8511L19.6111 27.6493C19.3678 27.8865 19.1042 28 18.8102 28Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.5241b12e5edc32b3c71a59b54ac8dc0a.svg";
export { ForwardRef as ReactComponent };